export default "__VITE_ASSET__P9E3Cnwn__"